import { InputTitle } from 'components/input/InputTitle';
import { Checkbox, Spacing, TextInput, Typography } from 'enable-ui';

import { Footer } from 'modules/dashboard/components/Footer';

import { useInstitutionFormController } from '../core/controller/institutions-form';

export const AddInstitutionPage = () => {
  const { values, handleChange, onChangeSwitch, handleSubmit, onCancel, disabled, emailStatus } =
    useInstitutionFormController();

  return (
    <div style={{ width: '70%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h3" style={{ marginBottom: 16 }} weight={700}>
          Add institution
        </Typography>
      </div>
      <Spacing spacing="md" placement="bottom" type="margin">
        <InputTitle title="Institution ID" />
        <TextInput
          name="code"
          containerStyle={{ maxWidth: 'auto' }}
          value={values.code}
          onChange={handleChange}
        />
      </Spacing>
      <Spacing spacing="md" placement="bottom" type="margin">
        <InputTitle title="Institution name" required />
        <TextInput
          name="name"
          containerStyle={{ maxWidth: 'auto' }}
          value={values.name}
          onChange={handleChange}
        />
      </Spacing>
      <Spacing spacing="md" placement="bottom" type="margin">
        <InputTitle title="Institution admin email" required />
        <TextInput
          name="email"
          containerStyle={{ maxWidth: 'auto' }}
          value={values.email}
          onChange={handleChange}
          helperText={emailStatus.helperText}
          color={emailStatus.color}
        />
      </Spacing>
      <Spacing
        spacing="md"
        placement="bottom"
        type="margin"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <Checkbox onClick={onChangeSwitch} checked={values.isSyncContent}>
          <Typography
            style={{
              textAlign: 'start',
            }}
          >
            Copy all library assets to this institution.
          </Typography>
        </Checkbox>
      </Spacing>
      <Footer onCancel={onCancel} onSubmit={handleSubmit} disabled={disabled} titleSubmit={'Add'} />
    </div>
  );
};
